import { Fragment, useState, useEffect } from "react";
import about from "../img/excvision.jpg";

const Laws = () => {
  const [isMobile, setIsMobile] = useState(false);

  //choose the screen size
  const handleResize = () => {
    if (window.innerWidth < 990) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };
  const alertUser = (e) => {
    e.preventDefault();
    e.returnValue = "";
  };
  useEffect(() => {
    window.scrollTo(0, 0);

    if (window.performance) {
      handleResize();

      if (performance.navigation.type == 1) {
        //     window.addEventListener("beforeunload", alertUser);
        return () => {
          window.addEventListener("resize", handleResize);

          //         window.removeEventListener("beforeunload", alertUser);
        };
      }
    }
  }, []);
  return (
    <Fragment>
      <div
        style={{
          position: "relative",
          top: !isMobile ? "100px" : "0px",
        }}
        class="container-fluid bg-primary py-5  mb-5"
        className="laws"
      >
        <div class="row py-3">
          <div class="col-12 text-center">
            <h1
              style={{
                marginTop: "90px",
              }}
              class="display-3 text-white animated zoomIn"
            >
              {" "}
              Laws{" "}
            </h1>
            <a href="/" class="h4 text-white">
              Home
            </a>
            <i class="far fa-circle text-white px-2"></i>
            <a href="" class="h4 text-white">
              Laws{" "}
            </a>
          </div>
        </div>
      </div>

      <div
        style={{
          position: "relative",
          top: !isMobile ? "100px" : "0px",
          marginBottom: !isMobile ? "100px" : "50px",
        }}
        className="container-fluid py-5 wow fadeInUp"
        data-wow-delay="0.1s"
      >
        {/* container1 */}

        <div className="container">
          <div className="row g-5">
            <div className="col-lg-7">
              <div className="section-title mb-4">
                <h5 className="position-relative d-inline-block text-primary text-uppercase">
                  Laws{" "}
                </h5>
                <h1 className="display-5 mb-0">
                  Our Care, Your Rights: The Laws and Standards We Follow
                </h1>
              </div>

              <div className="mb-4">
                <p>
                  Everyone we support has rights, and we are required by law to
                  meet high standards of care. These are the main laws and
                  standards that protect the people we support, their families
                  and our staff.
                </p>
                <h4 className="mt-4">The Health and Social Care Act 2008</h4>
                <p>
                  The Health and Social Care Act 2008 (Regulated Activities)
                  Regulations 2014 set out the "fundamental standards" that all
                  care providers in England must meet, so that people receive
                  care that is safe, effective, caring, responsive and well-led.
                </p>
                <h4 className="mt-4">The Care Quality Commission (CQC)</h4>
                <p>
                  The CQC is the independent regulator of health and adult
                  social care in England. It registers, inspects and rates care
                  services, and publishes its reports so that anyone can read
                  them.
                </p>
                <h4 className="mt-4">The Care Act 2014</h4>
                <p>
                  The Care Act puts people's wellbeing at the centre of care and
                  support. It also sets out how adults at risk of abuse or
                  neglect must be kept safe (safeguarding).
                </p>
                <h4 className="mt-4">The Mental Capacity Act 2005</h4>
                <p>
                  This law protects people who may not be able to make some
                  decisions for themselves. It means we always assume a person
                  can make their own decisions unless shown otherwise, support
                  them to make decisions wherever possible, and act in their
                  best interests when they cannot.
                </p>
                <h4 className="mt-4">The Equality Act 2010 and Human Rights Act 1998</h4>
                <p>
                  These laws protect people from discrimination and make sure
                  everyone is treated with dignity and respect, whatever their
                  age, disability, race, religion or belief, sex, sexual
                  orientation, gender reassignment, marriage or civil
                  partnership, or pregnancy and maternity.
                </p>
                <h4 className="mt-4">The Health and Safety at Work etc. Act 1974</h4>
                <p>
                  This law requires us to keep the people we support, our staff
                  and visitors as safe as reasonably possible.
                </p>
                <h4 className="mt-4">UK GDPR and the Data Protection Act 2018</h4>
                <p>
                  These laws control how personal information is collected,
                  stored and used. We keep personal and health information
                  confidential and secure. You can read more in our{" "}
                  <a href="/gdpr">privacy policy</a>.
                </p>
                <p className="mt-4">
                  If you have any questions or concerns about the care you or a
                  loved one receive, please call us on{" "}
                  <a href="tel:+441268988500">01268 988500</a> or email{" "}
                  <a href="mailto:info@excellence-care.co.uk">
                    info@excellence-care.co.uk
                  </a>
                  .
                </p>
              </div>
            </div>
            <div className="col-lg-5" style={{ minHeight: "500px" }}>
              <div className="position-relative h-100">
                <img
                  className="position-absolute w-100 h-100 rounded wow zoomIn"
                  data-wow-delay="0.9s"
                  src={about}
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Laws;
